// extracted by mini-css-extract-plugin
export default {"logo":"styles_logo__+KbnJ","mobile":"styles_mobile__KKHX5","desktop":"styles_desktop__smByF"};